import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { makeStyles, withStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import {
  Grid,
  Typography,
  TextField,
  FormControl,
  FormControlLabel,
  Checkbox,
  InputLabel,
  InputAdornment,
  IconButton,
  Button,
  Select,
  MenuItem,
  CircularProgress,
  Backdrop,
  ListItemText,
  ListItem,
  FormGroup,
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  Box,
} from "@material-ui/core";
import useStyles from "../../themes/style.js";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { FormProvider, useForm } from "react-hook-form";
import moment from "moment";
import { Controller } from "react-hook-form";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { useNotification } from "../../hooks/useNotification.js";
import { Autocomplete } from "@material-ui/lab";
import { useHistory } from "react-router-dom";
import { MdPayment } from "react-icons/md";
import { BsBank2 } from "react-icons/bs";
import { FaBuilding, FaFileAlt } from "react-icons/fa";
import { IoMdPerson } from "react-icons/io";
import contractImage from "../../images/gallery/contract-sign.jpg";
import { AddSquareIcon } from "../../components/svg/AdminUserTabIcon.js";

const dividerClass = {
  margin: "10px 0px",
  textAlign: "left",
  fontSize: "24px",
};

const subDividerClass = {
  margin: "15px 0px",
  textAlign: "left",
  fontSize: "18px",
};

const bloodGroups = ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"];
const gradeoptions = [
  { grade: "A1", description: "Exceptional Performance" },
  { grade: "A2", description: "Excellent Performance" },
  { grade: "B1", description: "Very Good Performance" },
  { grade: "B2", description: "Good Performance" },
  { grade: "C1", description: "Outstanding Performance" },
  { grade: "C2", description: "Above Average Performance" },
  { grade: "D1", description: "Average Performance" },
  { grade: "D2", description: "Below Average Performance" },
];

const workModeOptions = [
  { mode: "On-site", description: "Employee works at the company's premises" },
  { mode: "Remote", description: "Employee works from a remote location" },
  { mode: "Hybrid", description: "Combination of on-site and remote work" },
  {
    mode: "Flexible",
    description: "Employee can choose their own work schedule and location",
  },
];

const maritalStatusList = [
  "Single",
  "Married",
  "Divorced",
  "Widowed",
  "Separated",
  "Prefer not to say",
];

const formInputFields = [
  {
    id: 3,
    label: "HRA Arrears",
    placeholder: "Enter HRA Arrears",
    name: "hraArrears",
  },
  {
    id: 6,
    label: "Shift Allowance Arrears",
    placeholder: "Enter Shift Allowance Arrears",
    name: "shiftAllowanceArrears",
  },
  {
    id: 8,
    label: "Other Allowance Arrear",
    placeholder: "Enter Other Allowance Arrear",
    name: "otherAllowanceArrear",
  },
  {
    id: 9,
    label: "Telephone Allowance",
    placeholder: "Enter Telephone Allowance",
    name: "telephoneAllowance",
  },
  {
    id: 10,
    label: "Telephone Allowance Arrear",
    placeholder: "Enter Telephone Allowance Arrear",
    name: "telephoneAllowanceArrear",
  },
  {
    id: 11,
    label: "Conveyance",
    placeholder: "Enter Conveyance",
    name: "conveyance",
  },
  {
    id: 12,
    label: "Conveyance Arrears",
    placeholder: "Enter Conveyance Arrears",
    name: "conveyanceArrears",
  },
  {
    id: 13,
    label: "Medical Allowance",
    placeholder: "Enter Medical Allowance",
    name: "medicalAllowance",
  },
  {
    id: 14,
    label: "Medical Allowance Arrear",
    placeholder: "Enter Medical Allowance Arrear",
    name: "medicalAllowanceArrear",
  },
  {
    id: 15,
    label: "Basic Allowance",
    placeholder: "Enter Basic Allowance",
    name: "basicAllowance",
  },
  {
    id: 16,
    label: "Basic Allowance Arrears",
    placeholder: "Enter Basic Allowance Arrears",
    name: "basicAllowanceArrears",
  },
  { id: 17, label: "Bonus", placeholder: "Enter Bonus", name: "bonus" },
  {
    id: 18,
    label: "Incentives",
    placeholder: "Enter Incentives",
    name: "incentives",
  },
  {
    id: 19,
    label: "Other Earnings",
    placeholder: "Enter Other Earnings",
    name: "otherEarnings",
  },
  {
    id: 20,
    label: "Refund for Last Month Deduction",
    placeholder: "Enter Refund for Last Month Deduction",
    name: "refundForLastMonthDeduction",
  },
  {
    id: 21,
    label: "Arrears",
    placeholder: "Enter Arrears",
    name: "arrears",
  },
  {
    id: 22,
    label: "Consultant",
    placeholder: "Enter Consultant",
    name: "consultant",
  },
  {
    id: 23,
    label: "Consultant Arrears",
    placeholder: "Enter Consultant Arrears",
    name: "consultantArrears",
  },
  {
    id: 24,
    label: "Monthly Performance Arrears",
    placeholder: "Enter Monthly Performance Arrears",
    name: "monthlyPerformanceArrears",
  },
  {
    id: 25,
    label: "Role Performance Bonus",
    placeholder: "Enter Role Performance Bonus",
    name: "rolePerformanceBonus",
  },
  { id: 26, label: "PF", placeholder: "Enter PF", name: "pf" },
  { id: 27, label: "ESI", placeholder: "Enter ESI", name: "esi" },
  { id: 28, label: "VPF", placeholder: "Enter VPF", name: "vpf" },
  {
    id: 29,
    label: "Income Tax",
    placeholder: "Enter Income Tax",
    name: "incomeTax",
  },
  { id: 30, label: "Loan", placeholder: "Enter Loan", name: "loan" },
  {
    id: 31,
    label: "Others",
    placeholder: "Enter Others",
    name: "others",
  },
  {
    id: 32,
    label: "Labour Welfare Fund",
    placeholder: "Enter Labour Welfare Fund",
    name: "labourWelfareFund",
  },
  {
    id: 33,
    label: "Salary Advance",
    placeholder: "Enter Salary Advance",
    name: "salaryAdvance",
  },
  {
    id: 34,
    label: "Lunch Deduction",
    placeholder: "Enter Lunch Deduction",
    name: "lunchDeduction",
  },
  {
    id: 35,
    label: "Other Deduction",
    placeholder: "Enter Other Deduction",
    name: "otherDeduction",
  },
  {
    id: 36,
    label: "Notice Period Deduction",
    placeholder: "Enter Notice Period Deduction",
    name: "noticePeriodDeduction",
  },
  {
    id: 37,
    label: "Standard Deduction",
    placeholder: "Enter Standard Deduction",
    name: "standardDeduction",
  },
  {
    id: 38,
    label: "Special Purpose Deduction",
    placeholder: "Enter Special Purpose Deduction",
    name: "specialPurposeDeduction",
  },
];

const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    "& $line": {
      backgroundImage: "linear-gradient(to top, #f43b47 0%, #453a94 100%)",
    },
  },
  completed: {
    "& $line": {
      backgroundImage: "linear-gradient(to top, #f43b47 0%, #453a94 100%)",
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: "#eaeaf0",
    borderRadius: 1,
  },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: "#ccc",
    zIndex: 1,
    color: "#fff",
    width: 50,
    height: 50,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
  },
  active: {
    backgroundImage: "linear-gradient(to top, #f43b47 0%, #453a94 100%)",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  },
  completed: {
    backgroundImage: "linear-gradient(to top, #f43b47 0%, #453a94 100%)",
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <IoMdPerson size={20} />,
    2: <FaBuilding size={20} />,
    3: <FaFileAlt size={20} />,
    4: <BsBank2 size={20} />,
    5: <MdPayment size={20} />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  completed: PropTypes.bool,
  icon: PropTypes.node,
};

function getSteps() {
  return [
    "Personal Details",
    "Office Details",
    "Contract Details",
    "KYC Details",
    "Payslip Details",
  ];
}

export default function AddEmployeeSteps() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();
  const history = useHistory();
  const token = localStorage.getItem("token");
  const decode = jwtDecode(token);
  const handleNotificationCall = useNotification();
  console.log(activeStep, steps.length);

  const [values, setValues] = useState({
    showPassword: false,
  });
  const [userName, setUserName] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");

  const [loader, setLoader] = useState(false);
  const [selectedFields, setSelectedFields] = useState([]);
  const handleDropdownChange = (e) => {
    console.log(e.target);
    const selectedOptions = e.target.value;
    // const selectedOptions = Array.from(e.target.value).map(
    //   (option) => option.value,
    // );
    setSelectedFields(selectedOptions);
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const validationSchemas = [
    Yup.object().shape({
      roleName: Yup.string().required("User Category is required"),
      firstName: Yup.string()
        .max(255)
        .required("First Name is required")
        .matches(/^[^!@#$%^&*+=<>:;|~]*$/, {
          message: "First Name be Alphanumeric",
        }),
      lastName: Yup.string()
        .max(255)
        .required("Last Name is required")
        .matches(/^[^!@#$%^&*+=<>:;|~]*$/, {
          message: "Last Name be Alphanumeric",
        }),
      mobile: Yup.string()
        .required("Mobile is required")
        .min(10, "Must be exactly 10 digits")
        .max(10, "Must be exactly 10 digits"),

      //employee schema
      dob: Yup.date()
        .typeError("Invalid Date")
        .required("Date of Birth is required")
        .nullable(),
      gender: Yup.string().nullable().required("Gender is required"),
      bloodGroup: Yup.string().nullable().notRequired(),
      maritalStatus: Yup.string().nullable().notRequired(),
      spouseName: Yup.string().nullable().notRequired(),
      personalEmail: Yup.string()
        .required("Personal Email is required")
        .email("Email must be a Valid Email Address"),

      fatherName: Yup.string().required("Father Name is required"),
      motherName: Yup.string().required("Mother Name is required"),
      emergencyMobile: Yup.string()
        .required("Emergency Contact Number is required")
        .min(10, "Must be exactly 10 digits")
        .max(10, "Must be exactly 10 digits"),
      emergencyContactRelation: Yup.string(),
      currentAddress: Yup.string().required("Current Address is required"),
      permanentAddress: Yup.string().required("Permanent Address is required"),
      totalExperience: Yup.string().required(
        "Total Experience field is required",
      ),
    }),

    Yup.object().shape({
      email: Yup.string()
        .required("Email is required")
        .email("Email must be a Valid Email Address"),
      password: Yup.string()
        .required("Password is required")
        .min(8, "Password must be at least 8 characters"),
      joinningDate: Yup.date()
        .typeError("Invalid Date")
        .required("Date of joining is required")
        .nullable(),
      companyBranchName: Yup.string().nullable(),
      empId: Yup.string().nullable().notRequired(),
      designationId: Yup.string().nullable().notRequired(),
      department: Yup.string().nullable().notRequired(),
      DirectReportingTo: Yup.string(),
      DotReportingTo: Yup.string(),
      grade: Yup.string().nullable().required("This field is Required"),
      probationPeriod: Yup.number()
        .required("Mention Probation Period in month")
        .transform((_, val) => (val !== "" ? Number(val) : null))
        .typeError("value must be a number"),
      modeOfWork: Yup.string().nullable().required("This field is Required"),
    }),
    Yup.object().shape({
      isContract: Yup.boolean()
        .required("This field is required")
        .oneOf([true, false], "Invalid value for isContract"),
      contractClientName: Yup.string().when([], {
        is: () => isContract === true,
        then: Yup.string().required("Contract Client Name is required"),
        otherwise: Yup.string().nullable().notRequired(),
      }),
      contractStartDate: Yup.string().when([], {
        is: () => isContract === true,
        then: Yup.string().required("Contract Start Date is required"),
        otherwise: Yup.string().nullable().notRequired(),
      }),
      contractEndDate: Yup.string().when([], {
        is: () => isContract === true,
        then: Yup.string().required("Contract End Date is required"),
        otherwise: Yup.string().nullable().notRequired(),
      }),
      contractType: Yup.string().when([], {
        is: () => isContract === true,
        then: Yup.string().required("Contract Type is required"),
        otherwise: Yup.string().nullable().notRequired(),
      }),
      contractDetails: Yup.string().when([], {
        is: () => isContract === true,
        then: Yup.string().required("Contract Details is required"),
        otherwise: Yup.string().nullable().notRequired(),
      }),
    }),
    Yup.object().shape({
      aadhaarNumber: Yup.string().required("Aadhar Number is required"),
      panNumber: Yup.string().required("PAN Number is required"),
      pfNumber: Yup.string().nullable().notRequired(),
      uanNumber: Yup.string().nullable().notRequired(),
      esiNumber: Yup.string().nullable().notRequired(),
      bankName: Yup.string().nullable().notRequired(),
      bankAccountNumber: Yup.string().nullable().notRequired(),
      bankIfscCode: Yup.string().nullable().notRequired(),
    }),

    Yup.object().shape({
      isPfPercentage: Yup.boolean()
        .required("This field is required")
        .oneOf([true, false], "Invalid value for PF Select"),

      basicSalary: Yup.number()
        .required("This field is required")
        .min(0, "Minimum Value is 0")
        .transform((_, val) => (val !== "" ? Number(val) : null))
        .typeError("value must be a number"),
      hra: Yup.number()
        .typeError("value must be a number")
        .required("This field is required")
        .min(0, "Minimum Value is 0")
        .transform((_, val) => (val !== "" ? Number(val) : null)),
      specialAllowance: Yup.number()
        .required("This field is required")
        .min(0, "Minimum Value is 0")
        .transform((_, val) => (val !== "" ? Number(val) : null))
        .typeError("value must be a number"),
      shiftAllowance: Yup.number()
        .required("This field is required")
        .min(0, "Minimum Value is 0")
        .typeError("value must be a number")
        .required("This field is required")
        .min(0, "Minimum Value is 0")
        .transform((_, val) => (val !== "" ? Number(val) : null)),
      otherAllowance: Yup.number()
        .required("This field is required")
        .min(0, "Minimum Value is 0")
        .transform((_, val) => (val !== "" ? Number(val) : null))
        .typeError("value must be a number"),
      telephoneAllowance: Yup.number()
        .required("This field is required")
        .min(0, "Minimum Value is 0")
        .transform((_, val) => (val !== "" ? Number(val) : null))
        .typeError("value must be a number"),
      conveyance: Yup.number()
        .required("This field is required")
        .min(0, "Minimum Value is 0")
        .transform((_, val) => (val !== "" ? Number(val) : null))
        .typeError("value must be a number"),
      medicalAllowance: Yup.number()
        .required("This field is required")
        .transform((_, val) => (val !== "" ? Number(val) : null))
        .typeError("value must be a number"),
      basicAllowance: Yup.number()
        .required("This field is required")
        .min(0, "Minimum Value is 0")
        .transform((_, val) => (val !== "" ? Number(val) : null))
        .typeError("value must be a number"),
      statutoryBonus: Yup.number()
        .required("This field is required")
        .min(0, "Minimum Value is 0")
        .transform((_, val) => (val !== "" ? Number(val) : null))
        .typeError("value must be a number"),
      statutoryApplicability: Yup.number()
        .required("This field is required")
        .min(0, "Minimum Value is 0")
        .transform((_, val) => (val !== "" ? Number(val) : null))
        .typeError("value must be a number"),
    }),
  ];

  const methods = useForm({
    resolver: yupResolver(validationSchemas[activeStep]),
    mode: "onTouched",
    defaultValues: {
      probationPeriod: 0,
      isContract: false,
      contractStartDate: null,
      contractEndDate: null,

      isPfPercentage: true,
      basicSalary: 0,
      hra: 0,
      specialAllowance: 0,
      shiftAllowance: 0,
      otherAllowance: 0,
      telephoneAllowance: 0,
      conveyance: 0,
      medicalAllowance: 0,
      basicAllowance: 0,
      statutoryBonus: 0,
      statutoryApplicability: 0,
    },
  });
  const {
    register,
    control,
    trigger,
    handleSubmit,
    setValue,
    watch,
    formState: { errors, isSubmitting },
  } = methods;

  const isContract = watch("isContract");
  const isPfPercentage = watch("isPfPercentage");

  const basicSalary = watch("basicSalary");
  const hra = watch("hra");
  const specialAllowance = watch("specialAllowance");
  const shiftAllowance = watch("shiftAllowance");
  const otherAllowance = watch("otherAllowance");
  const telephoneAllowance = watch("telephoneAllowance");
  const conveyance = watch("conveyance");
  const medicalAllowance = watch("medicalAllowance");
  const basicAllowance = watch("basicAllowance");

  const totalGrossSalary = [
    basicSalary,
    hra,
    specialAllowance,
    shiftAllowance,
    otherAllowance,
    telephoneAllowance,
    conveyance,
    medicalAllowance,
    basicAllowance,
  ].reduce((acc, current) => Number(acc) + Number(current), 0);

  const PF = isPfPercentage ? Math.round(totalGrossSalary * 0.12) : 1800;
  const ESI = totalGrossSalary <= 21000 ? Math.abs(basicSalary * 0.0075) : 0;

  useEffect(() => {
    getAllUserList();
    fetchDeparmentsData();
  }, []);

  const getAllUserList = async () => {
    try {
      setLoader(true);

      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}auth/getAllUserList`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      setLoader(false);
      if (response.data.status) {
        const responseData = response.data.data;
        const userList = responseData.filter((item) => item.fullName !== null);
        setUserName(userList);
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const fetchDeparmentsData = async () => {
    try {
      setLoader(true);
      axios({
        method: "get",
        url: `${process.env.REACT_APP_SERVER}department/viewAll`,
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        setLoader(false);
        if (response.data.status === true) {
          setDepartmentData(response.data.data);
        }
      });
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const handleAddEmployee = async (values) => {
    setLoader(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}admin/addUser`,
        {
          ...values,
          contractDurations: {
            contractStartDate: values.contractStartDate,
            contractEndDate: values.contractEndDate,
            contractClientName: values.contractClientName,
            contractType: values.contractType,
            contractDetails: values.contractDetails,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        history.push("/app/employees");
      } else {
        handleNotificationCall("error", response.data.message);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const handleNext = async () => {
    const isStepValid = await trigger();
    if (isStepValid) {
      setActiveStep((prev) => prev + 1);
    }
    // setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const getDesignations = (departmentId) => {
    const department = departmentData.find((dept) => dept.id === departmentId);
    return department?.designations || [];
  };

  const designationDataOptions = getDesignations(selectedDepartment).map(
    (designation) => ({
      ...designation,
      group: designation.level.level, // Group by level name
    }),
  );

  const handleDepartmentChange = (value) => {
    setSelectedDepartment(value);
  };

  return (
    <>
      <div
        className={classes.flexCenter}
        style={{ padding: "30px 0px", width: "100%" }}
      >
        <div className="details-form-card employee-details-card">
          <div className="details-form-header p-2">
            <span className="icon">
              <AddSquareIcon size={32} />
            </span>
            <p className="alert mb-0 p-0">Add Employee</p>
          </div>
          <div>
            <Stepper
              alternativeLabel
              activeStep={activeStep}
              connector={<ColorlibConnector />}
              style={{ background: "transparent" }}
            >
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel StepIconComponent={ColorlibStepIcon}>
                    {label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
            <div>
              {activeStep === steps.length ? (
                <div>
                  <Typography className={classes.instructions}>
                    All steps completed - you&apos;re finished
                  </Typography>
                  <Button
                    type="button"
                    onClick={handleReset}
                    className={classes.button}
                  >
                    Reset
                  </Button>
                </div>
              ) : (
                <FormProvider {...methods}>
                  <form
                    onSubmit={handleSubmit(handleAddEmployee, (e) =>
                      console.log(e),
                    )}
                  >
                    {activeStep === 0 && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "12px",
                        }}
                      >
                        <Typography variant="body2" style={dividerClass}>
                          Personal Details
                        </Typography>
                        <Grid container direction="row" spacing={2}>
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <FormControl className={classes.margin}>
                              <InputLabel shrink htmlFor="roleName">
                                Select User Category
                              </InputLabel>

                              <Controller
                                name="roleName"
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                  <Select
                                    value={value}
                                    onChange={(e) => onChange(e.target.value)}
                                    error={errors.gender ? true : false}
                                    classes={{
                                      root: classes.customSelectField,
                                      icon: classes.customSelectIcon,
                                    }}
                                    disableUnderline
                                  >
                                    <MenuItem value="">Select option</MenuItem>
                                    <MenuItem key="recruiter" value="RECRUITER">
                                      Recruiter
                                    </MenuItem>
                                    <MenuItem
                                      key="clientCoordinator"
                                      value="CLIENTCOORDINATOR"
                                    >
                                      {decode.companyType === "COMPANY"
                                        ? "Hiring Manager"
                                        : "Client Coordinator"}
                                    </MenuItem>
                                    <MenuItem key="employee" value="EMPLOYEE">
                                      Employee
                                    </MenuItem>
                                  </Select>
                                )}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.roleName?.message}
                              </Typography>
                            </FormControl>
                          </Grid>
                        </Grid>
                        <Grid container direction="row" spacing={2}>
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="firstName">
                              First Name
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Enter First Name"
                                id="firstName"
                                name="firstName"
                                {...register("firstName")}
                                error={errors.firstName ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.firstName?.message}
                              </Typography>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="lastName">
                              Last Name
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                size="small"
                                placeholder="Enter Last Name"
                                id="lastName"
                                name="lastName"
                                {...register("lastName")}
                                error={errors.lastName ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.lastName?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="dob">
                              Date of Birth
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                InputProps={{ disableUnderline: true }}
                                classes={{ root: classes.customTextField }}
                                size="small"
                                type="date"
                                placeholder="Select employee date of birth"
                                id="dob"
                                {...register("dob")}
                                error={errors.dob ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.dob?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="gender">
                              Gender
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <Controller
                                name="gender"
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                  <Select
                                    value={value}
                                    onChange={(e) => onChange(e.target.value)}
                                    error={errors.gender ? true : false}
                                    classes={{
                                      root: classes.customSelectField,
                                      icon: classes.customSelectIcon,
                                    }}
                                    disableUnderline
                                  >
                                    <MenuItem value="">Select option</MenuItem>
                                    <MenuItem value="Male">Male</MenuItem>
                                    <MenuItem value="Female">Female</MenuItem>
                                    <MenuItem value="Transgender">
                                      Transgender
                                    </MenuItem>
                                    <MenuItem value="Prefer not to say">
                                      Prefer not to say
                                    </MenuItem>
                                  </Select>
                                )}
                              />
                              <Typography variant="inherit" color="error">
                                {errors.gender?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="bloodGroup">
                              Blood Group
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <Controller
                                name="bloodGroup"
                                control={control}
                                defaultValue=""
                                render={({ field: { onChange, value } }) => (
                                  <Select
                                    value={value}
                                    onChange={(e) => onChange(e.target.value)}
                                    error={errors.bloodGroup ? true : false}
                                    classes={{
                                      root: classes.customTextField,
                                      icon: classes.customSelectIcon,
                                    }}
                                    disableUnderline
                                  >
                                    <MenuItem value="">Select option</MenuItem>
                                    {bloodGroups.map((group) => (
                                      <MenuItem key={group} value={group}>
                                        {group}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                )}
                              />
                              <Typography variant="inherit" color="error">
                                {errors.bloodGroup?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="maritalStatus">
                              Marital Status
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <Controller
                                name="maritalStatus"
                                control={control}
                                defaultValue=""
                                render={({ field: { onChange, value } }) => (
                                  <Select
                                    value={value}
                                    onChange={(e) => onChange(e.target.value)}
                                    error={errors.maritalStatus ? true : false}
                                    classes={{
                                      root: classes.customTextField,
                                      icon: classes.customSelectIcon,
                                    }}
                                    disableUnderline
                                  >
                                    <MenuItem value="">Select option</MenuItem>
                                    {maritalStatusList.map((group) => (
                                      <MenuItem key={group} value={group}>
                                        {group}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                )}
                              />
                              <Typography variant="inherit" color="error">
                                {errors.maritalStatus?.message}
                              </Typography>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="spouseName">
                              Spouse Name
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Enter Spouse Name"
                                name="spouseName"
                                {...register("spouseName")}
                                error={errors.spouseName ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.spouseName?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="mobile">
                              Contact Number
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                size="small"
                                type="number"
                                placeholder="Enter Mobile Number"
                                id="mobile"
                                name="mobile"
                                {...register("mobile")}
                                error={errors.mobile ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.mobile?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="personalEmail">
                              Personal Email
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                size="small"
                                placeholder="Enter Persaonal Email"
                                name="personalEmail"
                                {...register("personalEmail")}
                                error={errors.personalEmail ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.personalEmail?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="fatherName">
                              Father Name
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Enter Father Name"
                                name="fatherName"
                                {...register("fatherName")}
                                error={errors.fatherName ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.fatherName?.message}
                              </Typography>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="motherName">
                              Mother Name
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                size="small"
                                placeholder="Enter Mother Name"
                                name="motherName"
                                {...register("motherName")}
                                error={errors.motherName ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.motherName?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="emergencyMobile">
                              Emergency Contact Number
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                size="small"
                                type="number"
                                placeholder="Enter Emergency Mobile Number"
                                id="emergencyMobile"
                                name="emergencyMobile"
                                {...register("emergencyMobile")}
                                error={errors.emergencyMobile ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.emergencyMobile?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel
                              shrink
                              htmlFor="emergencyContactRelation"
                            >
                              Emergency Contact Name & Relationship
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                size="small"
                                placeholder="Enter Emergency Contact Name & Relationship"
                                name="emergencyContactRelation"
                                {...register("emergencyContactRelation")}
                                error={
                                  errors.emergencyContactRelation ? true : false
                                }
                              />

                              <Typography variant="inherit" color="error">
                                {errors.emergencyContactRelation?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="currentAddress">
                              Current Address
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Enter Current Address"
                                name="currentAddress"
                                {...register("currentAddress")}
                                error={errors.currentAddress ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.currentAddress?.message}
                              </Typography>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="permanentAddress">
                              Permanent Address
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                size="small"
                                placeholder="Enter Permanent Address"
                                name="permanentAddress"
                                {...register("permanentAddress")}
                                error={errors.permanentAddress ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.permanentAddress?.message}
                              </Typography>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="totalExperience">
                              Total Experience (in Years)
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Enter Employee Total Experience"
                                name="totalExperience"
                                {...register("totalExperience")}
                                error={errors.totalExperience ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.totalExperience?.message}
                              </Typography>
                            </FormControl>
                          </Grid>
                        </Grid>
                      </div>
                    )}

                    {activeStep === 1 && (
                      <>
                        <Typography variant="body2" style={dividerClass}>
                          Office Details
                        </Typography>
                        <Grid container direction="row" spacing={2}>
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="email">
                              Official Email
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                size="small"
                                placeholder="Enter Email"
                                id="email"
                                name="email"
                                {...register("email")}
                                error={errors.email ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.email?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="password">
                              Password
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                classes={{ root: classes.customTextField }}
                                type={values.showPassword ? "text" : "password"}
                                placeholder="Enter Password"
                                id="password"
                                InputProps={{
                                  disableUnderline: true,
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                      >
                                        {values.showPassword ? (
                                          <Visibility />
                                        ) : (
                                          <VisibilityOff />
                                        )}
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                                {...register("password")}
                                error={errors.password ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.password?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="joinningDate">
                              Date of Joining
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                InputProps={{ disableUnderline: true }}
                                classes={{ root: classes.customTextField }}
                                size="small"
                                type="date"
                                placeholder="Select employee joining Date "
                                {...register("joinningDate")}
                                error={errors.joinningDate ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.joinningDate?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="empId">
                              Employee ID
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                size="small"
                                type="number"
                                placeholder="Enter Employee Id"
                                id="empId"
                                name="empId"
                                {...register("empId")}
                                error={errors.employeeId ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.empId?.message}
                              </Typography>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="companyBranchName">
                              Company Branch Name & Address
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Enter Company Branch Name & Address"
                                name="companyBranchName"
                                {...register("companyBranchName")}
                                error={errors.companyBranchName ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.companyBranchName?.message}
                              </Typography>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="probationPeriod">
                              Probation Period
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                type="number"
                                classes={{ root: classes.customTextField }}
                                InputProps={{
                                  disableUnderline: true,
                                  inputProps: { min: 0, inputMode: "numeric" },
                                }}
                                placeholder="Enter Probation Period"
                                name="probationPeriod"
                                {...register("probationPeriod")}
                                error={errors.probationPeriod ? true : false}
                                defaultValue={0}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.probationPeriod?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="grade">
                              Grade
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <Controller
                                name="grade"
                                control={control}
                                defaultValue=""
                                render={({ field: { onChange, value } }) => (
                                  <Select
                                    value={value}
                                    onChange={(e) => onChange(e.target.value)}
                                    error={errors.grade ? true : false}
                                    classes={{
                                      root: classes.customTextField,
                                      icon: classes.customSelectIcon,
                                    }}
                                    disableUnderline
                                  >
                                    {gradeoptions.map((group) => (
                                      <MenuItem
                                        key={group.grade}
                                        value={group.grade}
                                      >
                                        {group.grade}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                )}
                              />
                              <Typography variant="inherit" color="error">
                                {errors.grade?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="modeOfWork">
                              Mode of Work
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <Controller
                                name="modeOfWork"
                                control={control}
                                defaultValue=""
                                render={({ field: { onChange, value } }) => (
                                  <Select
                                    value={value}
                                    onChange={(e) => onChange(e.target.value)}
                                    error={errors.modeOfWork ? true : false}
                                    classes={{
                                      root: classes.customTextField,
                                      icon: classes.customSelectIcon,
                                    }}
                                    disableUnderline
                                  >
                                    <MenuItem value="">Select option</MenuItem>
                                    {workModeOptions.map((group) => (
                                      <MenuItem
                                        key={group.mode}
                                        value={group.mode}
                                      >
                                        {group.mode}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                )}
                              />
                              <Typography variant="inherit" color="error">
                                {errors.modeOfWork?.message}
                              </Typography>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <InputLabel shrink htmlFor="department">
                              Department
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <Controller
                                name="departmentId"
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                  <Select
                                    value={value || ""}
                                    onChange={(e) => {
                                      onChange(e.target.value);
                                      handleDepartmentChange(e.target.value);
                                    }}
                                    classes={{
                                      root: classes.customSelectField,
                                      icon: classes.customSelectIcon,
                                    }}
                                    error={errors.departmentId ? true : false}
                                    displayEmpty
                                    disableUnderline
                                  >
                                    <MenuItem value="" disabled>
                                      Select Department
                                    </MenuItem>
                                    {departmentData.map((dept) => (
                                      <MenuItem key={dept.id} value={dept.id}>
                                        {dept.title}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                )}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.departmentId?.message}
                              </Typography>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <InputLabel shrink htmlFor="designationId">
                              Designation
                            </InputLabel>
                            <FormControl fullWidth>
                              <Controller
                                name="designationId"
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                  <Controller
                                    name="designationId"
                                    control={control}
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <Autocomplete
                                        classes={{
                                          root: classes.designationSelect,
                                        }}
                                        options={designationDataOptions.sort(
                                          (a, b) =>
                                            a.group?.localeCompare(b?.group),
                                        )}
                                        groupBy={(option) => option.group}
                                        getOptionLabel={(option) =>
                                          option.title
                                        }
                                        onChange={(event, value) =>
                                          setValue(
                                            "designationId",
                                            value ? value.id : null,
                                          )
                                        }
                                        value={
                                          getDesignations(
                                            selectedDepartment,
                                          ).find((user) => user.id === value) ||
                                          null // Match the value
                                        }
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            label=""
                                            variant="filled"
                                            placeholder="Select Designation"
                                            className="requirement"
                                          />
                                        )}
                                        renderGroup={(params) => (
                                          <Box key={params.key}>
                                            <Box className={classes.designationGroupTitle}>
                                              <Typography
                                                variant="subtitle2"
                                                style={{
                                                  fontWeight: "bold",
                                                  color: "#3f51b5",
                                                }}
                                              >
                                                {params.group}
                                              </Typography>
                                            </Box>
                                            {params.children}
                                          </Box>
                                        )}
                                      />
                                    )}
                                  />
                                )}
                              />
                              <Typography variant="inherit" color="error">
                                {errors.designationId?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="DirectReportingTo">
                              Direct Reporting To:
                            </InputLabel>
                            <Controller
                              name="DirectReportingTo"
                              control={control}
                              render={({ field }) => (
                                <Autocomplete
                                  {...field}
                                  className="filterFullWidth"
                                  options={userName}
                                  getOptionLabel={(option) => option.fullName}
                                  onChange={(event, value) =>
                                    setValue(
                                      "DirectReportingTo",
                                      value ? value.id : null,
                                    )
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="standard"
                                      label=""
                                      InputLabelProps={{ shrink: true }}
                                      type="text"
                                    />
                                  )}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="DotReportingTo">
                              Dotted Reporting To:
                            </InputLabel>
                            <Controller
                              name="DotReportingTo"
                              control={control}
                              render={({ field }) => (
                                <Autocomplete
                                  {...field}
                                  className="filterFullWidth"
                                  options={userName}
                                  getOptionLabel={(option) => option.fullName}
                                  onChange={(event, value) =>
                                    setValue(
                                      "DotReportingTo",
                                      value ? value.id : null,
                                    )
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="standard"
                                      label=""
                                      InputLabelProps={{ shrink: true }}
                                      type="text"
                                    />
                                  )}
                                />
                              )}
                            />
                          </Grid>
                        </Grid>
                      </>
                    )}

                    {activeStep === 2 && (
                      <>
                        {!isContract ? (
                          <>
                            <Typography variant="body2" style={dividerClass}>
                              Contract Details
                            </Typography>
                            <Grid container direction="row" spacing={2}>
                              <Grid item xs={12} sm={6} md={8}>
                                <Box display="flex" alignItems="center">
                                  <img
                                    src={contractImage}
                                    className="img-fluid rounded-2"
                                    style={{
                                      height: "200px",
                                      objectFit: "cover",
                                    }}
                                    alt="contract details"
                                    width="100%"
                                    height="100%"
                                  />
                                </Box>
                              </Grid>
                              <Grid item xs={12} sm={6} md={4}>
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  flexDirection="column"
                                  height="100%"
                                  gridGap={16}
                                >
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    className="w-100"
                                    type="button"
                                    onClick={() => {
                                      setValue("isContract", true);
                                    }}
                                  >
                                    Add Employee Contract
                                  </Button>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    type="button"
                                    className="w-100"
                                    onClick={handleNext}
                                  >
                                    Skip
                                  </Button>
                                </Box>
                              </Grid>
                            </Grid>
                          </>
                        ) : (
                          <>
                            <Typography variant="body2" style={dividerClass}>
                              Contract Details
                            </Typography>
                            <Grid container direction="row" spacing={2}>
                              <Grid item xs={12} sm={6} md={6} lg={6}>
                                <InputLabel shrink htmlFor="contractClientName">
                                  Contract Client Name
                                </InputLabel>
                                <FormControl className={classes.margin}>
                                  <TextField
                                    size="small"
                                    classes={{
                                      root: classes.customTextField,
                                    }}
                                    InputProps={{ disableUnderline: true }}
                                    placeholder="Enter Contract Client Name"
                                    name="contractClientName"
                                    {...register("contractClientName")}
                                    error={
                                      errors.contractClientName ? true : false
                                    }
                                  />

                                  <Typography variant="inherit" color="error">
                                    {errors.contractClientName?.message}
                                  </Typography>
                                </FormControl>
                              </Grid>

                              <Grid item xs={12} sm={6} md={6} lg={6}>
                                <InputLabel shrink htmlFor="contractType">
                                  Contract Type
                                </InputLabel>
                                <FormControl className={classes.margin}>
                                  <TextField
                                    size="small"
                                    classes={{
                                      root: classes.customTextField,
                                    }}
                                    InputProps={{ disableUnderline: true }}
                                    placeholder="Enter Contract Type"
                                    name="contractType"
                                    {...register("contractType")}
                                    error={errors.contractType ? true : false}
                                  />

                                  <Typography variant="inherit" color="error">
                                    {errors.contractType?.message}
                                  </Typography>
                                </FormControl>
                              </Grid>

                              <Grid item xs={12} sm={6} md={6} lg={6}>
                                <InputLabel shrink htmlFor="contractDetails">
                                  Contract Detail
                                </InputLabel>
                                <FormControl className={classes.margin}>
                                  <TextField
                                    size="small"
                                    classes={{
                                      root: classes.customTextField,
                                    }}
                                    InputProps={{ disableUnderline: true }}
                                    placeholder="Enter Contract Client Detail"
                                    name="contractDetails"
                                    {...register("contractDetails")}
                                    error={
                                      errors.contractDetails ? true : false
                                    }
                                  />

                                  <Typography variant="inherit" color="error">
                                    {errors.contractDetails?.message}
                                  </Typography>
                                </FormControl>
                              </Grid>

                              <Grid item xs={12} sm={6} md={6} lg={6}>
                                <InputLabel shrink htmlFor="contractStartDate">
                                  Contract Start Date
                                </InputLabel>
                                <FormControl className={classes.margin}>
                                  <TextField
                                    size="small"
                                    type="date"
                                    classes={{
                                      root: classes.customTextField,
                                    }}
                                    InputProps={{ disableUnderline: true }}
                                    placeholder="Enter Contract Start Date"
                                    name="contractStartDate"
                                    {...register("contractStartDate")}
                                    error={
                                      errors.contractStartDate ? true : false
                                    }
                                  />

                                  <Typography variant="inherit" color="error">
                                    {errors.contractStartDate?.message}
                                  </Typography>
                                </FormControl>
                              </Grid>

                              <Grid item xs={12} sm={6} md={6} lg={6}>
                                <InputLabel shrink htmlFor="contractEndDate">
                                  Contract End Date
                                </InputLabel>
                                <FormControl className={classes.margin}>
                                  <TextField
                                    size="small"
                                    type="date"
                                    classes={{
                                      root: classes.customTextField,
                                    }}
                                    InputProps={{ disableUnderline: true }}
                                    placeholder="Enter Contract End Date"
                                    name="contractEndDate"
                                    {...register("contractEndDate")}
                                    error={
                                      errors.contractEndDate ? true : false
                                    }
                                  />

                                  <Typography variant="inherit" color="error">
                                    {errors.contractEndDate?.message}
                                  </Typography>
                                </FormControl>
                              </Grid>
                            </Grid>
                          </>
                        )}
                      </>
                    )}

                    {activeStep === 3 && (
                      <>
                        <Typography variant="body2" style={dividerClass}>
                          KYC Details
                        </Typography>
                        <Grid container direction="row" spacing={2}>
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="aadhaarNumber">
                              Aadhaar Number
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                size="small"
                                placeholder="Enter Aadhaar Number"
                                name="aadhaarNumber"
                                {...register("aadhaarNumber")}
                                error={errors.aadhaarNumber ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.aadhaarNumber?.message}
                              </Typography>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="panNumber">
                              PAN Number
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Enter PAN Number"
                                name="panNumber"
                                {...register("panNumber")}
                                error={errors.panNumber ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.panNumber?.message}
                              </Typography>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="uanNumber">
                              UAN Number
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Enter UAN Number"
                                name="uanNumber"
                                {...register("uanNumber")}
                                error={errors.uanNumber ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.uanNumber?.message}
                              </Typography>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="esiNumber">
                              ESI Number
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Enter ESI Number"
                                name="esiNumber"
                                {...register("esiNumber")}
                                error={errors.esiNumber ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.esiNumber?.message}
                              </Typography>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="pfNumber">
                              PF Number
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Enter PF Number"
                                name="pfNumber"
                                {...register("pfNumber")}
                                error={errors.pfNumber ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.pfNumber?.message}
                              </Typography>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="bankName">
                              Bank Name
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Enter Bank Name"
                                name="bankName"
                                {...register("bankName")}
                                error={errors.bankName ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.bankName?.message}
                              </Typography>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="bankAccountNumber">
                              Bank Account Number
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Enter Bank Account Number"
                                name="bankAccountNumber"
                                {...register("bankAccountNumber")}
                                error={errors.bankAccountNumber ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.bankAccountNumber?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="bankIfscCode">
                              Bank IFSC Code
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Enter Bank IfscCode"
                                name="bankIfscCode"
                                {...register("bankIfscCode")}
                                error={errors.bankIfscCode ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.bankIfscCode?.message}
                              </Typography>
                            </FormControl>
                          </Grid>
                        </Grid>
                      </>
                    )}
                    {activeStep === 4 && (
                      <>
                        <Typography variant="body2" style={dividerClass}>
                          Payslip Details
                        </Typography>

                        <Typography variant="body2" style={subDividerClass}>
                          Salary Master
                        </Typography>
                        <Grid container direction="row" spacing={2}>
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="basicSalary">
                              Basic Salary
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                type="number"
                                classes={{ root: classes.customTextField }}
                                InputProps={{
                                  disableUnderline: true,
                                  inputProps: { min: 0, inputMode: "numeric" },
                                }}
                                placeholder="Enter Basic Salary"
                                name="basicSalary"
                                {...register("basicSalary")}
                                error={errors.basicSalary ? true : false}
                                defaultValue={0}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.basicSalary?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="hra">
                              HRA
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                type="number"
                                classes={{ root: classes.customTextField }}
                                InputProps={{
                                  disableUnderline: true,
                                  inputProps: { min: 0, inputMode: "numeric" },
                                }}
                                placeholder="Enter HRA"
                                name="hra"
                                {...register("hra")}
                                error={errors.hra ? true : false}
                                defaultValue={0}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.hra?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="specialAllowance">
                              Special Allowance
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                type="number"
                                classes={{ root: classes.customTextField }}
                                InputProps={{
                                  disableUnderline: true,
                                  inputProps: { min: 0, inputMode: "numeric" },
                                }}
                                placeholder="Enter Special Allowance"
                                name="specialAllowance"
                                {...register("specialAllowance")}
                                error={errors.specialAllowance ? true : false}
                                defaultValue={0}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.specialAllowance?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="shiftAllowance">
                              Shift Allowance
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                type="number"
                                classes={{ root: classes.customTextField }}
                                InputProps={{
                                  disableUnderline: true,
                                  inputProps: { min: 0, inputMode: "numeric" },
                                }}
                                placeholder="Enter Shift Allowance"
                                name="shiftAllowance"
                                {...register("shiftAllowance")}
                                error={errors.shiftAllowance ? true : false}
                                defaultValue={0}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.shiftAllowance?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="otherAllowance">
                              Other Allowance
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                type="number"
                                classes={{ root: classes.customTextField }}
                                InputProps={{
                                  disableUnderline: true,
                                  inputProps: { min: 0, inputMode: "numeric" },
                                }}
                                placeholder="Enter Other Allowance"
                                name="otherAllowance"
                                {...register("otherAllowance")}
                                error={errors.otherAllowance ? true : false}
                                defaultValue={0}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.otherAllowance?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="telephoneAllowance">
                              Telephone Allowance
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                type="number"
                                classes={{ root: classes.customTextField }}
                                InputProps={{
                                  disableUnderline: true,
                                  inputProps: { min: 0, inputMode: "numeric" },
                                }}
                                placeholder="Enter Telephone Allowance"
                                name="telephoneAllowance"
                                {...register("telephoneAllowance")}
                                error={errors.telephoneAllowance ? true : false}
                                defaultValue={0}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.telephoneAllowance?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="conveyance">
                              Conveyance
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                type="number"
                                classes={{ root: classes.customTextField }}
                                InputProps={{
                                  disableUnderline: true,
                                  inputProps: { min: 0, inputMode: "numeric" },
                                }}
                                placeholder="Enter Conveyance"
                                name="conveyance"
                                {...register("conveyance")}
                                error={errors.conveyance ? true : false}
                                defaultValue={0}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.conveyance?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="medicalAllowance">
                              Medical Allowance
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                type="number"
                                classes={{ root: classes.customTextField }}
                                InputProps={{
                                  disableUnderline: true,
                                  inputProps: { min: 0, inputMode: "numeric" },
                                }}
                                placeholder="Enter Medical Allowance"
                                name="medicalAllowance"
                                {...register("medicalAllowance")}
                                error={errors.medicalAllowance ? true : false}
                                defaultValue={0}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.medicalAllowance?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="basicAllowance">
                              Basic Allowance
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                type="number"
                                classes={{ root: classes.customTextField }}
                                InputProps={{
                                  disableUnderline: true,
                                  inputProps: { min: 0, inputMode: "numeric" },
                                }}
                                placeholder="Enter Basic Allowance"
                                name="basicAllowance"
                                {...register("basicAllowance")}
                                error={errors.basicAllowance ? true : false}
                                defaultValue={0}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.basicAllowance?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="statutoryBonus">
                              Statutory Bonus
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                type="number"
                                classes={{ root: classes.customTextField }}
                                InputProps={{
                                  disableUnderline: true,
                                  inputProps: { min: 0, inputMode: "numeric" },
                                }}
                                placeholder="Enter Statutory Bonus"
                                name="statutoryBonus"
                                {...register("statutoryBonus")}
                                error={errors.statutoryBonus ? true : false}
                                defaultValue={0}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.statutoryBonus?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="statutoryApplicability">
                              Statutory Applicability
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                type="number"
                                classes={{ root: classes.customTextField }}
                                InputProps={{
                                  disableUnderline: true,
                                  inputProps: { min: 0, inputMode: "numeric" },
                                }}
                                placeholder="Enter Statutory Applicability"
                                name="statutoryApplicability"
                                {...register("statutoryApplicability")}
                                error={
                                  errors.statutoryApplicability ? true : false
                                }
                                defaultValue={0}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.statutoryApplicability?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12}>
                            <InputLabel shrink htmlFor="isPfPercentage">
                              PF Excess Contribution
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <Controller
                                name="isPfPercentage"
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                  <FormGroup row>
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          checked={value === true}
                                          onChange={() => onChange(true)}
                                        />
                                      }
                                      label="Employee & Employer contribution - 12% with in wage ceiling (Max Rs.1800)"
                                    />
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          checked={value === false}
                                          onChange={() => onChange(false)}
                                        />
                                      }
                                      label="Employee contribution - 12% over and above wage ceiling (In excess to Rs.1800)"
                                    />
                                  </FormGroup>
                                )}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.isPfPercentage?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12}>
                            <Box className="d-flex flex-column">
                              <Typography variant="body1">
                                Total Gross Salary: {totalGrossSalary}
                              </Typography>
                              <Typography variant="body1">
                                PF Amount: {PF}
                              </Typography>
                              <Typography component="div" variant="body1">
                                ESI :{" "}
                                <Typography component="span" variant="body1">
                                  {ESI}{" "}
                                </Typography>
                              </Typography>
                            </Box>
                          </Grid>
                          {/* <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="formField">
                              Select Fields
                            </InputLabel>

                            <Select
                              multiple
                              onChange={handleDropdownChange}
                              value={selectedFields}
                              classes={{
                                root: classes.customTextField,
                                icon: classes.customSelectIcon,
                              }}
                              disableUnderline
                              renderValue={(selected) =>
                                selected
                                  .map((value) => {
                                    const selectedItem = formInputFields.find(
                                      (field) => field.name === value,
                                    );
                                    return selectedItem
                                      ? selectedItem.label
                                      : value;
                                  })
                                  .join(", ")
                              }
                            >
                              {formInputFields.map((field) => (
                                <MenuItem key={field.id} value={field.name}>
                                  <Checkbox
                                    checked={
                                      selectedFields.indexOf(field.name) > -1
                                    }
                                  />
                                  {field.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </Grid>

                          {selectedFields.map((fieldName) => {
                            const field = formInputFields.find(
                              (f) => f.name === fieldName,
                            );
                            return (
                              <Grid item xs={12} sm={6} md={6} lg={6}>
                                <InputLabel shrink htmlFor={field?.name}>
                                  {field?.label}
                                </InputLabel>

                                <FormControl className={classes.margin}>
                                  <TextField
                                    size="small"
                                    classes={{
                                      root: classes.customTextField,
                                    }}
                                    type="number"
                                    InputProps={{ disableUnderline: true }}
                                    placeholder={field?.placeholder}
                                    name={field?.name}
                                    {...register(field.name)}
                                    // error={errors.field.name ? true : false}
                                  />

                                  <Typography variant="inherit" color="error">
                                    {errors[field.name]?.message}
                                  </Typography>
                                </FormControl>
                              </Grid>
                            );
                          })} */}
                        </Grid>
                      </>
                    )}

                    <Box
                      display="flex"
                      justifyContent="flex-end"
                      width="100%"
                      py={3}
                      gridGap={12}
                    >
                      <Button
                        type="button"
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        className={classes.button}
                      >
                        Back
                      </Button>
                      {isContract && activeStep === 2 && (
                        <Button
                          className={classes.button}
                          type="button"
                          onClick={() => {
                            handleNext();
                            setValue("isContract", false);
                          }}
                        >
                          Skip
                        </Button>
                      )}
                      <Button
                        variant="contained"
                        disabled={activeStep === steps.length - 1}
                        color="primary"
                        type="button"
                        onClick={handleNext}
                        className={classes.button}
                      >
                        Next
                      </Button>

                      <Button
                        type="submit"
                        disabled={activeStep !== steps.length - 1}
                        variant="contained"
                        color="primary"
                        className={classes.button}
                      >
                        Finish
                      </Button>
                    </Box>
                  </form>
                </FormProvider>
              )}
            </div>
          </div>
        </div>
        <Backdrop className={classes.backdrop} open={loader}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </>
  );
}
